module.exports = __webpack_public_path__ + "media/images/icon__delete--rb-orange@3x-1798256d00a17cd6100c719c1e7b3d8e.png";